function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DS = window.WinBoostAiDesignSystem_0f78b0 || {};
var Button = DS.Button,
  Card = DS.Card,
  Badge = DS.Badge,
  CheckItem = DS.CheckItem,
  SectionLabel = DS.SectionLabel,
  Icon = DS.Icon,
  Orbit = DS.Orbit,
  PatternBackdrop = DS.PatternBackdrop,
  Accordion = DS.Accordion;
var WA = '../../assets/';
var WPAT = WA + 'patterns/';
var CA_CITIES = [['Montréal', -73.57, 45.50, 11, -6], ['Toronto', -79.38, 43.65, 11, 13], ['Calgary', -114.07, 51.05, 11, 4], ['Winnipeg', -97.14, 49.90, 11, -6], ['Vancouver', -123.12, 49.28, -11, 4]];
var US_CITIES = [['New York', -74.01, 40.71, 11, 12], ['Chicago', -87.63, 41.88, 11, -6], ['Miami', -80.19, 25.76, 11, 4], ['Los Angeles', -118.24, 34.05, -11, 4]];
function Eyebrow(_ref) {
  var children = _ref.children,
    index = _ref.index;
  return React.createElement("div", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)',
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }
  }, React.createElement("span", null, children));
}
function NorthAmericaMap() {
  var ref = React.useRef(null);
  React.useEffect(function () {
    if (!window.d3 || !window.topojson) return;
    var w = 620,
      h = 480,
      el = ref.current;
    el.innerHTML = '';
    var svg = d3.select(el).append('svg').attr('viewBox', '0 0 ' + w + ' ' + h).attr('width', '100%').style('height', 'auto').style('display', 'block').style('overflow', 'hidden');
    var proj = d3.geoMercator().center([-96, 48]).scale(430).translate([w / 2, h / 2]);
    var path = d3.geoPath(proj);
    var KEEP = ['Canada', 'United States of America', 'Mexico', 'Greenland', 'Cuba', 'Bahamas', 'Guatemala', 'Honduras', 'Belize'];
    d3.json('https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-110m.json').then(function (topo) {
      var feats = topojson.feature(topo, topo.objects.countries).features.filter(function (d) {
        return KEEP.indexOf(d.properties.name) >= 0;
      });
      var g = svg.append('g');
      var fillFor = function fillFor(d) {
        return d.properties.name === 'Canada' ? '#F3E6D6' : d.properties.name === 'United States of America' ? '#FBF3E9' : '#FFFAF5';
      };
      g.selectAll('path.land').data(feats).join('path').attr('class', 'land').attr('d', path).attr('fill', fillFor).attr('stroke', '#E9DFD2').attr('stroke-width', .8).style('transition', 'fill .25s ease,stroke .25s ease').on('mouseenter', function () {
        d3.select(this).raise().attr('fill', '#FFE0CC').attr('stroke', 'var(--wb-orange)').attr('stroke-width', 1.2);
      }).on('mouseleave', function (e, d) {
        d3.select(this).attr('fill', fillFor(d)).attr('stroke', '#E9DFD2').attr('stroke-width', .8);
      });
      var home = feats.find(function (d) {
        return d.properties.name === 'Canada';
      });
      if (home) g.append('path').attr('d', path(home)).attr('fill', 'none').attr('stroke', 'var(--wb-orange)').attr('stroke-width', 1.1).attr('opacity', .55);
      var dots = svg.append('g');
      el.style.position = 'relative';
      var caL = d3.select(el).append('svg').attr('viewBox', '0 0 ' + w + ' ' + h).attr('width', '100%').attr('aria-hidden', 'true').style('height', 'auto').style('display', 'block').style('overflow', 'hidden').style('position', 'absolute').style('left', '0').style('top', '0').style('pointer-events', 'none').append('g');
      US_CITIES.forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 5),
          n = _ref3[0],
          lo = _ref3[1],
          la = _ref3[2],
          dx = _ref3[3],
          dy = _ref3[4];
        var p = proj([lo, la]);
        if (!p) return;
        dots.append('circle').attr('cx', p[0]).attr('cy', p[1]).attr('r', 5).attr('fill', 'none').attr('stroke', 'var(--wb-orange)').attr('stroke-width', 1.2).attr('opacity', .75);
        dots.append('text').attr('x', p[0] + dx).attr('y', p[1] + dy).attr('text-anchor', dx < 0 ? 'end' : 'start').text(n).attr('font-size', 11).attr('font-weight', 700).attr('fill', 'var(--ink-500)');
      });
      CA_CITIES.forEach(function (_ref4, i) {
        var _ref5 = _slicedToArray(_ref4, 5),
          n = _ref5[0],
          lo = _ref5[1],
          la = _ref5[2],
          dx = _ref5[3],
          dy = _ref5[4];
        var p = proj([lo, la]);
        if (!p) return;
        caL.append('circle').attr('cx', p[0]).attr('cy', p[1]).attr('r', 12).attr('fill', 'var(--wb-orange)').attr('opacity', .12).attr('class', 'wb-map-pulse').style('animation-delay', i * .7 + 's');
        caL.append('circle').attr('cx', p[0]).attr('cy', p[1]).attr('r', 4).attr('fill', 'var(--wb-orange)');
        caL.append('text').attr('x', p[0] + dx).attr('y', p[1] + dy).attr('text-anchor', dx < 0 ? 'end' : 'start').text(n).attr('font-size', 11.5).attr('font-weight', 800).attr('fill', 'var(--ink-800)');
      });
    });
  }, []);
  return React.createElement("div", {
    ref: ref,
    "aria-hidden": "true",
    style: {
      width: '100%',
      minHeight: 360
    }
  });
}
function WhoWeAre() {
  return React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1.05fr)',
      gap: 'clamp(28px,3vw,54px)',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 22
    }
  }, React.createElement(Eyebrow, {
    index: "16 /"
  }, "Pourquoi WinBoost"), React.createElement("h2", {
    id: "why-winboost-title",
    style: {
      fontSize: 'var(--fs-h1)',
      lineHeight: 'var(--lh-h1)',
      letterSpacing: 'var(--ls-h1)',
      fontWeight: 800
    }
  }, "Con\u00e7u au Canada.", React.createElement("br", null), "Con\u00e7u pour gagner partout."), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body-lg)',
      lineHeight: 'var(--lh-body-lg)'
    }
  }, "WinBoost.ai est une entreprise canadienne de technologie d\u2019IA qui se consacre \u00e0 une seule chose\u00a0: b\u00e2tir une technologie d\u2019IA qui g\u00e9n\u00e8re une vraie croissance des revenus pour les entreprises du Canada et des \u00c9tats-Unis."), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-secondary)'
    }
  }, "Nos \u00e9quipes de consultants en IA et de concepteurs d\u2019AI Phone se d\u00e9ploient \u00e0 Montr\u00e9al, Toronto, Calgary, Winnipeg et Vancouver, ainsi qu\u2019aux \u00c9tats-Unis, y compris New York, Chicago, au Texas et en Californie."), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-secondary)'
    }
  }, "Nous concevons des syst\u00e8mes AI Phone sur mesure qui aident les entreprises \u00e0 r\u00e9pondre aux appels, \u00e0 engager les leads, \u00e0 automatiser les suivis, \u00e0 r\u00e9server des rendez-vous et \u00e0 soutenir leurs clients plus rapidement."), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-secondary)'
    }
  }, "Nous concevons aussi ", React.createElement("strong", {
    style: {
      color: 'var(--text-primary)'
    }
  }, "Active AI Orbit"), ", une exp\u00e9rience de site Web vocale. Les visiteurs parlent \u00e0 votre site au lieu d\u2019\u00e9crire, obtiennent des r\u00e9ponses en temps r\u00e9el et r\u00e9servent des rendez-vous directement dans votre calendrier, 24/7, sur ordinateur, tablette et mobile."), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 28,
      paddingTop: 24,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, React.createElement("h3", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)',
      margin: 0
    }
  }, "Conseillers AI Phone Canada"), React.createElement("ul", {
    style: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      fontSize: 15,
      fontWeight: 700
    }
  }, CA_CITIES.map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 1),
      c = _ref7[0];
    return React.createElement("li", {
      key: c
    }, "Conseillers AI Phone ", c);
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, React.createElement("h3", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)',
      margin: 0
    }
  }, "Conseillers AI Phone \u00c9tats-Unis"), React.createElement("ul", {
    style: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      fontSize: 15,
      fontWeight: 700,
      color: 'var(--text-secondary)'
    }
  }, US_CITIES.map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 1),
      c = _ref9[0];
    return React.createElement("li", {
      key: c
    }, "Conseillers AI Phone ", c);
  })))), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 20,
      flexWrap: 'wrap',
      paddingTop: 26,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    arrow: true,
    href: "#final-form"
  }, "Parler \u00e0 un conseiller AI Phone"), React.createElement("a", {
    href: "/pages/ai-phone-directory",
    style: {
      fontSize: 15,
      fontWeight: 700,
      color: 'var(--wb-orange)',
      textDecoration: 'underline',
      textUnderlineOffset: 3
    }
  }, "Au service des entreprises du Canada et des \u00c9tats-Unis."))), React.createElement(NorthAmericaMap, null));
}
var H5 = [['01', 'L\u2019humain d\u2019abord', 'La technologie devrait sembler plus humaine, pas moins.'], ['02', 'Toujours actif', 'Chaque occasion m\u00e9rite une r\u00e9ponse.'], ['03', 'Con\u00e7u pour gagner', 'Tout ce que nous configurons a un but\u00a0: des r\u00e9sultats.'], ['04', 'Ensemble, on gagne', 'Votre succ\u00e8s est notre succ\u00e8s.'], ['05', 'Placer la barre plus haut', 'Faire mieux, c\u2019est ce que nous configurons chaque jour.']];
var FINGERS_UNUSED = null;
function fingerPath(bx, by, len, wb, wt, ang, bend) {
  var a = ang * Math.PI / 180,
    dx = Math.sin(a),
    dy = -Math.cos(a),
    px = Math.cos(a),
    py = Math.sin(a);
  var f = function f(v) {
    return v.toFixed(1);
  };
  var b1x = bx + px * wb / 2,
    b1y = by + py * wb / 2,
    b2x = bx - px * wb / 2,
    b2y = by - py * wb / 2;
  var tx = bx + dx * len,
    ty = by + dy * len;
  var t1x = tx + px * wt / 2,
    t1y = ty + py * wt / 2,
    t2x = tx - px * wt / 2,
    t2y = ty - py * wt / 2;
  var mx = bx + dx * len * 0.55,
    my = by + dy * len * 0.55;
  var c1x = mx + px * (wb / 2 + bend),
    c1y = my + py * (wb / 2 + bend);
  var c2x = mx - px * (wb / 2 - bend),
    c2y = my - py * (wb / 2 - bend);
  return 'M' + f(b1x) + ' ' + f(b1y) + ' Q' + f(c1x) + ' ' + f(c1y) + ' ' + f(t1x) + ' ' + f(t1y) + ' A' + f(wt / 2) + ' ' + f(wt / 2) + ' 0 0 1 ' + f(t2x) + ' ' + f(t2y) + ' Q' + f(c2x) + ' ' + f(c2y) + ' ' + f(b2x) + ' ' + f(b2y) + ' Z';
}
var PALM_FINGERS = [fingerPath(55, 102, 62, 21, 17, -14, 2), fingerPath(74, 98, 70, 22, 18, -2, 2), fingerPath(93, 101, 64, 21, 17, 12, 2), fingerPath(109, 110, 48, 18, 15, 26, 1.5), fingerPath(44, 150, 54, 24, 20, -70, 3)];
var PALM_BODY = 'M34 92C30 132 34 162 52 180C66 195 100 195 110 176C120 152 116 116 112 92Z';
function PalmShapes(_ref0) {
  var color = _ref0.color;
  return React.createElement(React.Fragment, null, React.createElement("g", {
    fill: color
  }, PALM_FINGERS.map(function (d, i) {
    return React.createElement("path", {
      key: i,
      d: d
    });
  }), React.createElement("path", {
    d: PALM_BODY
  }), React.createElement("rect", {
    x: "48",
    y: "170",
    width: "58",
    height: "42",
    rx: "14",
    fill: "var(--wb-charcoal)"
  })), React.createElement("g", {
    stroke: "var(--wb-cream)",
    strokeWidth: "2.6",
    strokeLinecap: "round",
    fill: "none",
    opacity: ".9"
  }, React.createElement("path", {
    d: "M59 102c-2 12-2 22 0 32"
  }), React.createElement("path", {
    d: "M76 98c-2 13-2 24 0 36"
  }), React.createElement("path", {
    d: "M93 102c-2 12-2 22 0 30"
  }), React.createElement("path", {
    d: "M49 168h56"
  })));
}
var STAR = 'M0 -11c1.6 6.6 2.8 7.8 9.4 9.4C2.8 -0.0 1.6 1.2 0 7.8c-1.6-6.6-2.8-7.8-9.4-9.4C-2.8-3.0-1.6-4.2 0-11z';
var FOREARM = 'M44 150C38 202 30 252 24 300L88 306C98 246 104 196 108 152Z';
function HandArm(_ref1) {
  var fill = _ref1.fill,
    line = _ref1.line;
  return React.createElement(React.Fragment, null, React.createElement("g", {
    fill: fill,
    stroke: line,
    strokeWidth: "4",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: FOREARM
  }), PALM_FINGERS.map(function (d, i) {
    return React.createElement("path", {
      key: i,
      d: d
    });
  }), React.createElement("path", {
    d: PALM_BODY
  })), React.createElement("g", {
    stroke: line,
    strokeWidth: "3.4",
    strokeLinecap: "round",
    fill: "none"
  }, React.createElement("path", {
    d: "M59 102c-2 14-2 26 0 38"
  }), React.createElement("path", {
    d: "M76 98c-2 15-2 28 0 42"
  }), React.createElement("path", {
    d: "M93 102c-2 14-2 26 0 36"
  }), React.createElement("path", {
    d: "M52 150c16 8 38 8 54 0"
  })));
}
var RAYS = [['M130 46L116 18', 0], ['M160 36L160 6', .2], ['M190 46L204 18', .4]];
function useReveal(repeat) {
  var ref = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    go = _React$useState2[0],
    setGo = _React$useState2[1];
  React.useEffect(function () {
    var el = ref.current;
    if (!el) {
      setGo(true);
      return;
    }
    var inView = function inView() {
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight * 0.85 && r.bottom > 0;
    };
    var _check = function check() {
      var v = inView();
      if (v) {
        setGo(true);
        if (!repeat) window.removeEventListener('scroll', _check);
        return true;
      }
      if (repeat) setGo(false);
      return false;
    };
    _check();
    window.addEventListener('scroll', _check, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', _check);
    };
  }, [repeat]);
  return [ref, go];
}
var STARS = [[4, 30, 12, 'var(--wb-gold)', 0], [24, 10, 16, 'var(--wb-amber)', .25], [50, 2, 18, 'var(--wb-orange)', .5], [76, 10, 14, 'var(--wb-gold)', .75], [96, 30, 13, 'var(--wb-amber)', 1]];
function HighFiveMark() {
  var _useReveal = useReveal(),
    _useReveal2 = _slicedToArray(_useReveal, 2),
    ref = _useReveal2[0],
    go = _useReveal2[1];
  return React.createElement("div", {
    ref: ref,
    style: {
      position: 'relative',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      padding: '46px 22px 0'
    }
  }, STARS.map(function (_ref10, i) {
    var _ref11 = _slicedToArray(_ref10, 5),
      x = _ref11[0],
      y = _ref11[1],
      s = _ref11[2],
      c = _ref11[3],
      d = _ref11[4];
    return React.createElement("svg", {
      key: i,
      viewBox: "-12 -12 24 24",
      width: s,
      height: s,
      "aria-hidden": "true",
      style: {
        position: 'absolute',
        left: x + '%',
        top: y + 'px',
        marginLeft: -s / 2,
        opacity: 0,
        animation: go ? 'wb-twinkle 2.6s ' + (.9 + d) + 's var(--ease-standard) infinite' : 'none'
      }
    }, React.createElement("path", {
      d: STAR,
      fill: c
    }));
  }), React.createElement("span", {
    style: {
      position: 'relative',
      display: 'block',
      width: '100%',
      maxWidth: 230,
      background: 'var(--grad-brand)',
      WebkitMaskImage: 'url("' + (window.__wbFix ? window.__wbFix(WA + 'high-five.png') : WA + 'high-five.png') + '")',
      maskImage: 'url("' + (window.__wbFix ? window.__wbFix(WA + 'high-five.png') : WA + 'high-five.png') + '")',
      WebkitMaskSize: '100% 100%',
      maskSize: '100% 100%',
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',
      opacity: go ? 1 : 0,
      animation: go ? 'wb-rise 2s var(--ease-out) both' : 'none'
    }
  }, React.createElement("img", {
    src: WA + 'high-five.png',
    alt: "",
    "aria-hidden": "true",
    style: {
      width: '100%',
      height: 'auto',
      display: 'block',
      visibility: 'hidden'
    }
  })));
}
function High5() {
  var _React$useState3 = React.useState(1),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    open = _React$useState4[0],
    setOpen = _React$useState4[1];
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(20px,2vw,30px)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14
    }
  }, React.createElement(Eyebrow, null, "Le High 5 WinBoost"), React.createElement("h2", {
    style: {
      fontSize: 'var(--fs-h2)',
      lineHeight: 'var(--lh-h2)',
      letterSpacing: 'var(--ls-h2)',
      fontWeight: 800
    }
  }, "Cinq valeurs. Une seule norme."), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-secondary)'
    }
  }, "Les principes qui guident la fa\u00e7on dont nous configurons, innovons, soutenons nos clients et grandissons ensemble.")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) clamp(176px,18vw,240px)',
      gap: 'clamp(24px,3vw,56px)',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      borderTop: '1px solid var(--border-hairline)'
    }
  }, H5.map(function (_ref12, i) {
    var _ref13 = _slicedToArray(_ref12, 3),
      n = _ref13[0],
      t = _ref13[1],
      d = _ref13[2];
    return React.createElement("div", {
      key: n,
      onMouseEnter: function onMouseEnter() {
        return setOpen(i);
      },
      style: {
        display: 'grid',
        gridTemplateColumns: 'clamp(52px,4.6vw,76px) minmax(0,.9fr) minmax(0,1.3fr)',
        gap: 'clamp(16px,1.8vw,32px)',
        alignItems: 'center',
        padding: 'clamp(13px,1.3vw,18px) 0',
        borderBottom: '1px solid var(--border-hairline)',
        background: open === i ? 'linear-gradient(90deg,rgba(255,174,6,.07),rgba(255,250,245,0) 70%)' : 'transparent',
        transition: 'background var(--dur-base) var(--ease-standard)'
      }
    }, React.createElement("span", {
      style: {
        fontSize: 'clamp(22px,2.1vw,30px)',
        fontWeight: 800,
        letterSpacing: '-.03em',
        lineHeight: 1,
        background: open === i ? 'var(--grad-brand)' : 'none',
        WebkitBackgroundClip: open === i ? 'text' : undefined,
        backgroundClip: open === i ? 'text' : undefined,
        color: open === i ? 'transparent' : 'var(--ink-300)',
        transition: 'color var(--dur-base) var(--ease-standard)'
      }
    }, n), React.createElement("h3", {
      style: {
        fontSize: 'clamp(15px,1.25vw,18px)',
        fontWeight: 800,
        letterSpacing: '.02em',
        textTransform: 'uppercase'
      }
    }, t), React.createElement("p", {
      style: {
        fontSize: 'var(--fs-body-sm)',
        lineHeight: 'var(--lh-body-sm)',
        color: 'var(--text-secondary)'
      }
    }, d));
  })), React.createElement(HighFiveMark, null)));
}
var MATTERS = [['L\u2019humain d\u2019abord', 'Des conversations con\u00e7ues pour \u00eatre naturelles, utiles et fid\u00e8les \u00e0 votre marque.'], ['Toujours actif', 'Votre entreprise peut r\u00e9pondre, engager et saisir des occasions au-del\u00e0 des heures de travail de votre \u00e9quipe.'], ['Con\u00e7u pour gagner', 'Chaque flux de travail est con\u00e7u autour d\u2019un objectif d\u2019affaires, de la r\u00e9ponse aux appels \u00e0 la qualification des leads et \u00e0 la prise de rendez-vous.'], ['Ensemble, on gagne', 'Votre AI Phone est configur\u00e9 autour de votre entreprise, de votre \u00e9quipe, de vos flux de travail et de vos objectifs.'], ['Placer la barre plus haut', 'Nous testons, peaufinons et am\u00e9liorons sans cesse la technologie derri\u00e8re l\u2019exp\u00e9rience de vos clients.']];
var OUTCOMES = [['R\u00e9ponse plus rapide', 'clock-24'], ['Plus d\u2019appels capt\u00e9s', 'phone-ring'], ['Plus de leads qualifi\u00e9s', 'funnel'], ['Plus de r\u00e9servations', 'calendar'], ['Meilleure exp\u00e9rience client', 'headset']];
function WhyItMatters() {
  var BUBBLES = [[7, 0, 'var(--wb-orange)', 6, -16], [5, .8, 'var(--wb-gold)', 7.2, 10], [9, 1.7, 'var(--wb-amber)', 6.6, -4], [4, 2.5, 'var(--wb-orange)', 7.8, 20], [6, 3.4, 'var(--wb-gold)', 6.2, -24], [5, 4.2, 'var(--wb-amber)', 7, 4], [7, 5, 'var(--wb-orange)', 6.8, -12], [4, 5.8, 'var(--wb-gold)', 7.4, 16]];
  var _useReveal3 = useReveal(true),
    _useReveal4 = _slicedToArray(_useReveal3, 2),
    listRef = _useReveal4[0],
    listGo = _useReveal4[1];
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(30px,3vw,48px)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      alignItems: 'center',
      textAlign: 'center'
    }
  }, React.createElement(Eyebrow, null, "Pourquoi c\u2019est important"), React.createElement("h2", {
    style: {
      fontSize: 'var(--fs-h1)',
      lineHeight: 'var(--lh-h1)',
      letterSpacing: 'var(--ls-h1)',
      fontWeight: 800
    }
  }, "Nos valeurs sont int\u00e9gr\u00e9es \u00e0 votre AI Phone."), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-secondary)'
    }
  }, "Le High 5 n\u2019est pas quelque chose qu\u2019on accroche au mur. Il fa\u00e7onne la fa\u00e7on dont nous configurons chaque WinBoost AI Phone et dont nous soutenons les entreprises qui les utilisent.")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1.35fr) minmax(180px,.7fr) minmax(0,.85fr)',
      gap: 'clamp(20px,2.6vw,48px)',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    ref: listRef,
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, MATTERS.map(function (_ref14, i) {
    var _ref15 = _slicedToArray(_ref14, 2),
      t = _ref15[0],
      d = _ref15[1];
    return React.createElement("div", {
      key: t,
      style: {
        display: 'grid',
        gridTemplateColumns: '12px minmax(0,1fr)',
        gap: 16,
        alignItems: 'start',
        padding: '16px 0',
        borderTop: i ? '1px solid var(--border-hairline)' : 'none',
        opacity: listGo ? 1 : 0,
        animation: listGo ? 'wb-rise .5s ' + i * 0.12 + 's var(--ease-out) both' : 'none'
      }
    }, React.createElement("span", {
      "aria-hidden": "true",
      style: {
        width: 7,
        height: 7,
        marginTop: 9,
        borderRadius: '50%',
        background: 'var(--wb-orange)'
      }
    }), React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 5
      }
    }, React.createElement("h3", {
      className: "wb-label",
      style: {
        letterSpacing: '.12em'
      }
    }, t), React.createElement("p", {
      style: {
        fontSize: 15,
        lineHeight: 1.6,
        color: 'var(--text-secondary)'
      }
    }, d)));
  })), React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 14
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-400)',
      textAlign: 'center'
    }
  }, "Fa\u00e7onne la technologie"), React.createElement(Orbit, {
    size: 148,
    state: "breathing",
    detail: true,
    halo: true,
    basePath: WA
  }), React.createElement("span", {
    style: {
      fontSize: 13,
      fontWeight: 800,
      letterSpacing: '.06em',
      textTransform: 'uppercase',
      color: 'var(--wb-orange)'
    }
  }, "WinBoost AI Phone Lead Closer"), React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      left: '-13%',
      right: '-13%',
      top: '50%',
      height: 0,
      zIndex: 0,
      pointerEvents: 'none'
    }
  }, BUBBLES.map(function (_ref16, i) {
    var _ref17 = _slicedToArray(_ref16, 5),
      s = _ref17[0],
      d = _ref17[1],
      c = _ref17[2],
      dur = _ref17[3],
      off = _ref17[4];
    return React.createElement("span", {
      key: i,
      style: {
        position: 'absolute',
        top: off - s / 2,
        width: s,
        height: s,
        borderRadius: '50%',
        background: c,
        boxShadow: '0 0 0 3px rgba(255,255,255,.55)',
        opacity: 0,
        animation: 'wb-bubble-x ' + dur + 's ' + d + 's linear infinite'
      }
    });
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-400)',
      marginBottom: 4
    }
  }, "Cr\u00e9e de la valeur pour l\u2019entreprise"), OUTCOMES.map(function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 2),
      o = _ref19[0],
      ic = _ref19[1];
    return React.createElement("div", {
      key: o,
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 14px',
        borderRadius: 'var(--radius-md)',
        background: 'var(--surface-card)',
        border: '1px solid var(--border-card)',
        fontSize: 15,
        fontWeight: 700
      }
    }, React.createElement(Icon, {
      name: ic,
      size: 26,
      basePath: WA + 'icons/',
      style: {
        flex: '0 0 auto'
      }
    }), o);
  }))));
}
var RD_GROUPS = [['IA vocale', [{
  q: 'Qu\u2019est-ce qu\u2019un syst\u00e8me t\u00e9l\u00e9phonique IA pour entreprise?',
  a: 'Un syst\u00e8me t\u00e9l\u00e9phonique IA r\u00e9pond aux appels de votre entreprise avec une IA vocale conversationnelle plut\u00f4t qu\u2019un menu IVR ou une bo\u00eete vocale. Le WinBoost AI Phone r\u00e9pond d\u00e8s la premi\u00e8re sonnerie 24/7, parle d\u2019une voix humaine naturelle et r\u00e9pond aux questions sur vos services, vos tarifs, vos heures et votre territoire desservi \u00e0 partir de vos propres informations.'
}, {
  q: 'Le WinBoost AI Phone est-il offert au Canada et aux \u00c9tats-Unis?',
  a: 'Oui. Le WinBoost AI Phone est offert aux entreprises du Canada et des \u00c9tats-Unis, avec des num\u00e9ros de t\u00e9l\u00e9phone locaux dans les deux pays. Il fonctionne aussi \u00e0 l\u2019\u00e9chelle mondiale\u00a0: les appelants peuvent le joindre de partout dans le monde, et il r\u00e9pond dans leur langue.'
}, {
  q: 'Quelles langues l\u2019AI Phone parle-t-il?',
  a: "Toutes les langues de vos appelants. Le WinBoost AI Phone d\u00e9tecte automatiquement la langue de l\u2019appelant et peut changer en cours d\u2019appel, de sorte qu\u2019un appelant anglophone, francophone ou hispanophone obtient la m\u00eame conversation naturelle."
}, {
  q: 'La voix semble-t-elle humaine?',
  a: 'Oui. Chaque r\u00e9ponse est prononc\u00e9e d\u2019une voix naturelle, semblable \u00e0 celle d\u2019un humain. Il continue d\u2019\u00e9couter pendant qu\u2019il parle, alors les appelants peuvent l\u2019interrompre, changer d\u2019id\u00e9e ou poser une question de suivi comme avec une personne.'
}, {
  q: "L\u2019AI Phone peut-il utiliser la voix d\u2019un membre de mon \u00e9quipe?",
  a: "Oui, avec le consentement de cette personne. WinBoost peut cloner la voix d\u2019un membre de l\u2019\u00e9quipe pour que votre AI Phone sonne comme quelqu\u2019un que vos clients connaissent d\u00e9j\u00e0. Une voix clon\u00e9e n\u2019est utilis\u00e9e que pour votre propre entreprise."
}, {
  q: 'Combien d\u2019appels peut-il traiter en m\u00eame temps?',
  a: 'Jusqu\u2019\u00e0 20 appels en m\u00eame temps, alors les heures de pointe, les promotions et les rushs saisonniers n\u2019envoient jamais un appelant \u00e0 la bo\u00eete vocale ou \u00e0 un signal d\u2019occupation.'
}]], ['Automatisation des avis', [{
  q: 'Comment l\u2019AI Phone recueille-t-il des avis Google?',
  a: 'Apr\u00e8s chaque appel ou rendez-vous termin\u00e9, le WinBoost SMS Reviews AI Phone envoie au client une courte demande d\u2019avis par texto avec un lien direct vers votre profil d\u2019entreprise Google. Les clients satisfaits laissent un avis en quelques touches, pendant que l\u2019exp\u00e9rience est encore fra\u00eeche.'
}, {
  q: 'R\u00e9pond-il aux avis \u00e0 ma place?',
  a: 'Oui. Il r\u00e9pond \u00e0 chaque nouvel avis avec le ton que vous avez approuv\u00e9, en remerciant les avis positifs et en r\u00e9pondant professionnellement aux pr\u00e9occupations, pour que votre profil reste actif et \u00e0 jour.'
}, {
  q: 'Que se passe-t-il en cas de mauvaise exp\u00e9rience?',
  a: 'Les commentaires n\u00e9gatifs sont d\u2019abord achemin\u00e9s \u00e0 votre \u00e9quipe, pour que vous puissiez faire un suivi et r\u00e9gler la situation directement. Chaque demande, r\u00e9ponse et note est visible dans votre portail client.'
}, {
  q: 'Comment plus d\u2019avis aident-ils mon entreprise \u00e0 \u00eatre trouv\u00e9e?',
  a: 'Plus d\u2019avis r\u00e9cents et positifs font grimper votre profil d\u2019entreprise Google dans les r\u00e9sultats de recherche locale. Les plateformes d\u2019IA comme ChatGPT, Claude et Gemini lisent aussi les avis publics quand elles recommandent des entreprises, alors une solide r\u00e9putation vous aide aussi \u00e0 y \u00eatre cit\u00e9.'
}, {
  q: 'Combien co\u00fbte l\u2019automatisation des avis?',
  a: 'Le SMS Reviews AI Phone est un ajout unique de 697\u00a0$ (habituellement 997\u00a0$), et il fonctionne avec votre AI Phone pour appels entrants ou sortants. Ensuite, vous payez seulement 0,05\u00a0$ par texto envoy\u00e9.'
}]], ['Automatisation des appels', [{
  q: 'Comment cesser de manquer des appels d\u2019affaires apr\u00e8s les heures d\u2019ouverture?',
  a: 'L\u2019automatisation des appels du WinBoost AI Phone r\u00e9pond la nuit, les fins de semaine, les jours f\u00e9ri\u00e9s et en cas de d\u00e9bordement, pour qu\u2019aucun appel n\u2019aille \u00e0 la bo\u00eete vocale. Chaque appel est pris d\u00e8s la premi\u00e8re sonnerie, consign\u00e9 avec un enregistrement et une transcription, puis achemin\u00e9 ou r\u00e9serv\u00e9 selon vos r\u00e8gles.'
}]], ['SMS', [{
  q: 'L\u2019IA peut-elle r\u00e9pondre aux demandes des clients par texto?',
  a: 'L\u2019automatisation des textos du WinBoost AI Phone r\u00e9pond aux textos entrants, qualifie la demande, envoie des liens de r\u00e9servation et confirme les rendez-vous dans une conversation d\u2019affaires bidirectionnelle par texto, reli\u00e9e \u00e0 l\u2019historique des appels.'
}, {
  q: 'Comment r\u00e9duire les absences aux rendez-vous gr\u00e2ce aux textos?',
  a: 'Des confirmations et des rappels automatiques partent du WinBoost AI Phone apr\u00e8s chaque r\u00e9servation, avec une gestion des changements d\u2019horaire par texto. Moins de rendez-vous oubli\u00e9s, c\u2019est moins de plages vides pour les cliniques, les services \u00e0 domicile, les salons et les concessionnaires.'
}, {
  q: 'L\u2019IA peut-elle relancer des soumissions et des leads froids par texto?',
  a: 'Oui. Le WinBoost AI Phone ex\u00e9cute des suivis automatiques par texto et des s\u00e9quences de r\u00e9engagement sur les soumissions, les appels manqu\u00e9s et les leads inactifs, pour que les occasions soient travaill\u00e9es plut\u00f4t qu\u2019oubli\u00e9es.'
}]], ['Engagement des leads', [{
  q: 'Qu\u2019est-ce que la rapidit\u00e9 de r\u00e9ponse aux leads et pourquoi est-elle importante?',
  a: 'La rapidit\u00e9 de r\u00e9ponse aux leads, c\u2019est la vitesse \u00e0 laquelle vous r\u00e9pondez apr\u00e8s qu\u2019on vous a contact\u00e9; la conversion chute fortement apr\u00e8s les premi\u00e8res minutes. WinBoost AI Phone r\u00e9pond instantan\u00e9ment, 24/7, alors chaque lead entrant a une vraie conversation pendant que l\u2019intention est encore \u00e9lev\u00e9e.'
}, {
  q: 'L\u2019IA peut-elle qualifier les leads avant qu\u2019ils atteignent mon \u00e9quipe de vente?',
  a: 'La qualification de leads par IA du WinBoost AI Phone recueille le service requis, le lieu, la fourchette de budget, l\u2019urgence et l\u2019\u00e9ch\u00e9ancier d\u00e8s la premi\u00e8re conversation, puis dirige les leads qualifi\u00e9s vers votre closer ou votre calendrier et entretient automatiquement les autres.'
}]], ['Automatisation des flux de travail', [{
  q: 'Comment l\u2019automatisation des processus d\u2019affaires fait-elle gagner du temps \u00e0 mon \u00e9quipe?',
  a: 'La prise de notes manuelle, la saisie de donn\u00e9es et les listes de rappels disparaissent. L\u2019automatisation des flux de travail du WinBoost AI Phone consigne le r\u00e9sultat de chaque appel et cr\u00e9e la prochaine action, pour que votre \u00e9quipe consacre ses heures au travail qui g\u00e9n\u00e8re des revenus.'
}, {
  q: 'Puis-je consulter des rapports sur chaque appel trait\u00e9 par l\u2019IA?',
  a: 'Chaque appel, transcription, r\u00e9servation, paiement et suivi trait\u00e9s par votre WinBoost AI Phone est visible dans le portail client d\u00e8s qu\u2019il se produit, avec les minutes utilis\u00e9es et restantes.'
}]], ['Active AI Orbit', [{
  q: 'Qu\u2019est-ce qu\u2019Active AI Orbit?',
  a: 'Active AI Orbit est une exp\u00e9rience de site Web vocale con\u00e7ue par WinBoost.ai. Les visiteurs parlent \u00e0 votre site au lieu de remplir des formulaires. Il r\u00e9pond \u00e0 leurs questions en temps r\u00e9el, les qualifie et r\u00e9serve des rendez-vous dans votre calendrier, 24/7, sur ordinateur, tablette et mobile.'
}, {
  q: 'Comment un site Web vocal capte-t-il plus de leads?',
  a: 'La plupart des visiteurs partent sans remplir de formulaire. Active AI Orbit lance plut\u00f4t une conversation\u00a0: pas de saisie, pas d\u2019attente d\u2019un rappel. Il qualifie le visiteur pendant qu\u2019il est encore sur la page, recueille ses coordonn\u00e9es et envoie une confirmation par texto quand une r\u00e9servation est faite.'
}, {
  q: 'Active AI Orbit fonctionne-t-il avec mon WinBoost AI Phone?',
  a: 'Oui. Active AI Orbit utilise les m\u00eames connaissances, les m\u00eames r\u00e8gles de r\u00e9servation et le m\u00eame calendrier que votre WinBoost AI Phone, alors un visiteur de votre site et un appelant sur votre ligne t\u00e9l\u00e9phonique obtiennent les m\u00eames r\u00e9ponses et la m\u00eame exp\u00e9rience.'
}]], ['IA conversationnelle', [{
  q: 'Qu\u2019est-ce que l\u2019IA conversationnelle pour les appels t\u00e9l\u00e9phoniques?',
  a: 'L\u2019IA conversationnelle comprend l\u2019intention et tient un vrai \u00e9change au lieu de lire un script. Le WinBoost AI Phone pose des questions de qualification, g\u00e8re les interruptions et les questions de service complexes, et s\u2019adapte \u00e0 la fa\u00e7on de parler de l\u2019appelant.'
}, {
  q: 'L\u2019IA peut-elle g\u00e9rer les objections pendant un appel?',
  a: 'Oui. Le WinBoost AI Phone r\u00e9pond aux objections sur les prix, le moment et la confiance avec votre positionnement approuv\u00e9, puis oriente la conversation vers une r\u00e9servation, un transfert ou un suivi.'
}, {
  q: 'En quoi est-ce diff\u00e9rent d\u2019un IVR ou d\u2019un robot conversationnel?',
  a: 'Un IVR trie les appelants dans des menus et un robot conversationnel attend sur votre site Web. L\u2019IA conversationnelle du WinBoost AI Phone r\u00e9pond au t\u00e9l\u00e9phone, comprend la demande et m\u00e8ne le travail \u00e0 terme\u00a0: qualifier, r\u00e9server, capturer le paiement ou transf\u00e9rer.'
}]], ['IA de conclusion de ventes', [{
  q: 'L\u2019IA peut-elle conclure des ventes au t\u00e9l\u00e9phone?',
  a: 'Le Sale Closer AI du WinBoost AI Phone pr\u00e9sente votre offre, confirme le d\u00e9cideur, r\u00e9pond aux objections sur les prix, capture un paiement ou un d\u00e9p\u00f4t et r\u00e9serve le rendez-vous avant que l\u2019appelant raccroche.'
}, {
  q: 'Qu\u2019est-ce qu\u2019un agent de vente IA pour les appels entrants?',
  a: 'Un agent de vente IA traite chaque demande entrante avec la m\u00eame discipline de script que votre meilleur closer, \u00e0 toute heure. Le WinBoost AI Phone m\u00e8ne cette conversation la nuit, les fins de semaine et les jours f\u00e9ri\u00e9s, sans horaire de quarts.'
}, {
  q: 'L\u2019AI Phone peut-il capturer des paiements et des d\u00e9p\u00f4ts?',
  a: 'Oui. Le WinBoost AI Phone peut prendre des d\u00e9p\u00f4ts et des paiements pendant l\u2019appel ou par lien de paiement par texto, puis confirmer la r\u00e9servation et consigner la transaction dans votre CRM.'
}]]];
var RD_LABELS = RD_GROUPS.map(function (g) {
  return g[0];
});
function Innovation() {
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    group = _React$useState6[0],
    setGroup = _React$useState6[1];
  return React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(320px,.85fr)',
      gap: 'clamp(28px,3vw,54px)',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20
    }
  }, React.createElement(Eyebrow, null, "Recherche et d\u00e9veloppement"), React.createElement("h2", {
    style: {
      fontSize: 'var(--fs-h1)',
      lineHeight: 'var(--lh-h1)',
      letterSpacing: 'var(--ls-h1)',
      fontWeight: 800
    }
  }, "L\u2019innovation avec un but\u00a0: des r\u00e9sultats."), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-secondary)'
    }
  }, "Nous recherchons, testons et d\u00e9veloppons sans cesse l\u2019automatisation AI Phone, l\u2019IA vocale, l\u2019automatisation des textos et la technologie d\u2019engagement client qui aident les entreprises \u00e0 saisir plus d\u2019occasions, \u00e0 soutenir leurs \u00e9quipes, \u00e0 am\u00e9liorer l\u2019exp\u00e9rience client et \u00e0 faire cro\u00eetre leurs revenus. Notre R-D se concentre sur une innovation pratique en IA qui cr\u00e9e des r\u00e9sultats d\u2019affaires mesurables.")), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 'clamp(20px,2.4vw,34px)'
    }
  }, React.createElement("div", {
    style: {
      position: 'relative',
      width: '100%',
      aspectRatio: '1.15',
      borderRadius: 'var(--radius-xl)',
      overflow: 'hidden',
      background: 'var(--sand-200)'
    }
  }, React.createElement("video", {
    src: "assets/rd-lab.mp4",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    "aria-label": "Un consultant en IA au travail",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  }))), React.createElement("p", {
    style: {
      gridColumn: '1 / -1',
      fontSize: 'clamp(26px,2.9vw,42px)',
      lineHeight: 1.15,
      letterSpacing: '-.028em',
      fontWeight: 800,
      marginTop: 14,
      paddingTop: 26,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, "Si \u00e7a ne cr\u00e9e pas de vraie valeur pour l\u2019entreprise, ", React.createElement("span", {
    style: {
      background: 'var(--grad-brand)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent'
    }
  }, "\u00e7a ne passe pas.")), React.createElement("div", {
    className: "wb-rd-faq",
    style: {
      gridColumn: '1 / -1',
      display: 'grid',
      gridTemplateColumns: '240px 1fr',
      gap: 56,
      alignItems: 'start'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2
    }
  }, RD_LABELS.map(function (g, i) {
    return React.createElement("button", {
      key: g,
      onClick: function onClick() {
        return setGroup(i);
      },
      style: {
        all: 'unset',
        cursor: 'pointer',
        padding: '12px 16px',
        borderRadius: 'var(--radius-sm)',
        fontSize: 14,
        fontWeight: 800,
        background: group === i ? 'var(--wb-white)' : 'transparent',
        color: group === i ? 'var(--wb-orange)' : 'var(--ink-600)',
        border: '1px solid ' + (group === i ? 'var(--border-card)' : 'transparent')
      }
    }, g);
  })), React.createElement(Accordion, {
    key: group,
    defaultOpen: [0],
    items: RD_GROUPS[group][1]
  })));
}
function OurPeople() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(30px,3vw,48px)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18,
      maxWidth: 820
    }
  }, React.createElement(Eyebrow, null, "Notre \u00e9quipe"), React.createElement("h2", {
    style: {
      fontSize: 'var(--fs-h1)',
      lineHeight: 'var(--lh-h1)',
      letterSpacing: 'var(--ls-h1)',
      fontWeight: 800
    }
  }, "Rencontrez une \u00e9quipe GAGNANTE"), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14
    }
  }, React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body-lg)',
      lineHeight: 'var(--lh-body-lg)',
      fontWeight: 700
    }
  }, "Une grande technologie commence par de grandes personnes."), React.createElement("p", {
    style: {
      fontSize: 'var(--fs-body)',
      lineHeight: 'var(--lh-body)',
      color: 'var(--text-secondary)'
    }
  }, "Nous b\u00e2tissons des \u00e9quipes o\u00f9 les gens peuvent grandir professionnellement et personnellement, collaborer, innover et \u00eatre fiers des r\u00e9sultats que nous cr\u00e9ons pour nos clients."))), React.createElement("div", {
    style: {
      width: '100%',
      aspectRatio: '2.83/1',
      borderRadius: 'var(--radius-xl)',
      overflow: 'hidden'
    }
  }, React.createElement("img", {
    src: "assets/team%20photo%20WinBoost%202026.jpg",
    alt: "L\u2019\u00e9quipe de WinBoost.ai",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center 40%',
      display: 'block'
    }
  })), React.createElement("p", {
    style: {
      fontSize: 'clamp(28px,3.2vw,46px)',
      lineHeight: 1.1,
      letterSpacing: '-.03em',
      fontWeight: 800,
      textAlign: 'center',
      margin: '0 auto'
    }
  }, "Quand l\u2019un de nous gagne, nous gagnons tous."));
}
function LetsTalk() {
  var cols = [['01', 'Conseiller AI Phone', 'Parlez \u00e0 l\u2019un de nos conseillers AI Phone de votre syst\u00e8me t\u00e9l\u00e9phonique actuel, de votre r\u00e9ponse aux leads et de votre processus d\u2019engagement client.'], ['02', 'Diagnostic', 'Nous cernerons o\u00f9 les appels, les leads et les occasions peuvent se perdre, et nous vous montrerons comment l\u2019automatisation AI Phone peut soutenir votre \u00e9quipe et vos efforts de marketing actuels.'], ['03', 'La configuration de votre AI Phone', 'Ensuite, nous configurons un syst\u00e8me WinBoost AI Phone sur mesure qui travaille aux c\u00f4t\u00e9s de votre entreprise pour r\u00e9pondre aux appels, engager les leads, qualifier les occasions, r\u00e9server des rendez-vous, faire le suivi, envoyer des textos et entretenir les clients en quelques secondes.']];
  return React.createElement("div", {
    className: "lt-card"
  }, React.createElement("style", null, '@property --lt-a{syntax:"<angle>";inherits:false;initial-value:0deg}.lt-card{position:relative;overflow:hidden;border-radius:var(--radius-xl);border:3px solid transparent;background:radial-gradient(60% 55% at 85% 0%,rgba(252,99,6,.22),transparent 70%) padding-box,radial-gradient(45% 50% at 0% 100%,rgba(255,174,6,.12),transparent 70%) padding-box,linear-gradient(180deg,#1C1C1C,#141414) padding-box,conic-gradient(from var(--lt-a),#FFAE06,#FC6306,#FFAE06 50%,#FC6306,#FFAE06) border-box;animation:ltRing 6s linear infinite;padding:clamp(24px,3vw,48px);color:#FFFFFF;box-shadow:0 30px 70px -24px rgba(23,23,23,.5)}@keyframes ltRing{to{--lt-a:360deg}}.lt-eye{display:inline-flex;align-items:center;gap:10px;font-size:12px;font-weight:800;letter-spacing:.2em;text-transform:uppercase;color:var(--wb-gold)}.lt-eye i{width:28px;height:2px;border-radius:2px;background:linear-gradient(90deg,#FFAE06,#FC6306)}.lt-h{margin:0;font-size:var(--fs-h2);line-height:1.12;letter-spacing:-.03em;font-weight:800;color:#FFFFFF;text-wrap:balance}.lt-g{background:linear-gradient(90deg,#FFAE06,#FC6306);-webkit-background-clip:text;background-clip:text;color:transparent;padding-bottom:.06em}.lt-steps{position:relative;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:clamp(14px,1.6vw,22px)}.lt-rail{position:absolute;left:calc(16.66% );right:calc(16.66%);top:27px;height:2px;border-radius:2px;background:linear-gradient(90deg,rgba(255,174,6,.25),rgba(252,99,6,.25));overflow:hidden}.lt-rail b{position:absolute;inset:0;width:30%;background:linear-gradient(90deg,transparent,#FFAE06,#FC6306,transparent);animation:ltRun 3.2s ease-in-out infinite}@keyframes ltRun{0%{transform:translateX(-100%)}100%{transform:translateX(340%)}}.lt-step{position:relative;display:flex;flex-direction:column;align-items:center;text-align:center;gap:12px}.lt-num{position:relative;z-index:1;width:56px;height:56px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:17px;font-weight:800;letter-spacing:-.02em;color:#171717;background:linear-gradient(0deg,#FFAE06,#FC6306);box-shadow:0 0 0 6px #181818,0 10px 26px -8px rgba(252,99,6,.7)}.lt-panel{display:flex;flex-direction:column;gap:8px;width:100%;flex:1;background:#292929;border:1px solid #3A3A3A;border-radius:var(--radius-lg);padding:clamp(16px,1.6vw,22px);transition:border-color var(--dur-base) var(--ease-standard),transform var(--dur-base) var(--ease-standard)}.lt-step:hover .lt-panel{border-color:var(--wb-orange);transform:translateY(-3px)}.lt-panel h3{margin:0;font-size:17px;font-weight:800;letter-spacing:-.02em;color:#FFFFFF}.lt-panel p{margin:0;font-size:14.5px;line-height:1.6;color:#C8C8C8}.lt-close{display:flex;flex-direction:column;align-items:center;text-align:center;gap:clamp(16px,2vw,24px);padding-top:clamp(20px,2.2vw,30px);border-top:1px solid #333333}.lt-close p{margin:0;font-size:clamp(20px,2vw,28px);line-height:1.3;letter-spacing:-.02em;font-weight:800;color:#FFFFFF}.lt-btns{display:flex;gap:14px;flex-wrap:wrap;justify-content:center}.lt-ghost:hover{background:#292929!important;border-color:var(--wb-gold)!important}@media(max-width:820px){.lt-steps{grid-template-columns:minmax(0,1fr)}.lt-rail{display:none}}@media(prefers-reduced-motion:reduce){.lt-card,.lt-rail b{animation:none}}'), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(26px,2.8vw,40px)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: 14,
      maxWidth: 760,
      margin: '0 auto'
    }
  }, React.createElement("span", {
    className: "lt-eye"
  }, React.createElement("i", null), "Parlons-en", React.createElement("i", null)), React.createElement("h2", {
    className: "lt-h"
  }, "Trouvons votre ", React.createElement("span", {
    className: "lt-g"
  }, "goulot d\u2019\u00e9tranglement de l\u2019attention."))), React.createElement("div", {
    className: "lt-steps"
  }, React.createElement("span", {
    className: "lt-rail",
    "aria-hidden": "true"
  }, React.createElement("b", null)), cols.map(function (_ref20) {
    var _ref21 = _slicedToArray(_ref20, 3),
      n = _ref21[0],
      label = _ref21[1],
      body = _ref21[2];
    return React.createElement("div", {
      key: n,
      className: "lt-step"
    }, React.createElement("span", {
      className: "lt-num"
    }, n), React.createElement("div", {
      className: "lt-panel"
    }, React.createElement("h3", null, label), React.createElement("p", null, body)));
  })), React.createElement("div", {
    className: "lt-close"
  }, React.createElement("p", null, "Transformez plus de conversations en occasions.", React.createElement("br", null), React.createElement("span", {
    className: "lt-g"
  }, "Transformez plus d\u2019occasions en revenus.")), React.createElement("div", {
    className: "lt-btns"
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    arrow: true,
    href: "#final-form"
  }, "Parler \u00e0 un conseiller en IA"), React.createElement(Button, {
    variant: "outline",
    size: "lg",
    arrow: true,
    href: "#hear-it",
    className: "lt-ghost",
    style: {
      color: '#FFFFFF',
      borderColor: '#FFFFFF',
      background: 'transparent'
    }
  }, "Appelez notre AI Phone")))));
}
function WhySchema() {
  React.useEffect(function () {
    if (document.getElementById('wb-why-ld')) return;
    var cities = CA_CITIES.map(function (_ref22) {
      var _ref23 = _slicedToArray(_ref22, 1),
        c = _ref23[0];
      return {
        '@type': 'City',
        name: c,
        containedInPlace: {
          '@type': 'Country',
          name: 'Canada'
        }
      };
    }).concat(US_CITIES.map(function (_ref24) {
      var _ref25 = _slicedToArray(_ref24, 1),
        c = _ref25[0];
      return {
        '@type': 'City',
        name: c,
        containedInPlace: {
          '@type': 'Country',
          name: '\u00c9tats-Unis'
        }
      };
    }));
    var org = {
      '@type': 'Organization',
      '@id': 'https://winboost.ai/#org',
      name: 'WinBoost.ai',
      url: 'https://winboost.ai/',
      description: 'Entreprise canadienne de technologie d\u2019IA qui configure des syst\u00e8mes AI Phone sur mesure et des sites Web vocaux Active AI Orbit pour les entreprises du Canada et des \u00c9tats-Unis.',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'CA'
      },
      areaServed: cities
    };
    var prods = [{
      '@type': 'Product',
      name: 'WinBoost AI Phone',
      brand: {
        '@id': 'https://winboost.ai/#org'
      },
      description: 'Un AI Phone sur mesure qui r\u00e9pond \u00e0 chaque appel d\u2019affaires 24/7, qualifie les leads, g\u00e8re les objections, r\u00e9serve des rendez-vous, capture les paiements et envoie des suivis par texto.',
      offers: {
        '@type': 'Offer',
        price: '2997',
        priceCurrency: 'USD',
        description: 'Achat unique, puis paiement \u00e0 la minute.'
      }
    }, {
      '@type': 'Product',
      name: 'Active AI Orbit',
      brand: {
        '@id': 'https://winboost.ai/#org'
      },
      description: 'Une exp\u00e9rience de site Web vocale qui parle aux visiteurs en temps r\u00e9el, r\u00e9pond aux questions, qualifie les leads et r\u00e9serve des rendez-vous 24/7.',
      offers: {
        '@type': 'Offer',
        price: '1997',
        priceCurrency: 'USD',
        description: 'Achat unique.'
      }
    }];
    var faq = {
      '@type': 'FAQPage',
      mainEntity: RD_GROUPS.flatMap(function (g) {
        return g[1].filter(Boolean);
      }).map(function (x) {
        return {
          '@type': 'Question',
          name: x.q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: x.a
          }
        };
      })
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.id = 'wb-why-ld';
    s.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': [org].concat(prods, [faq])
    });
    document.head.appendChild(s);
  }, []);
  return null;
}
function WhyWinBoost() {
  return React.createElement("section", {
    id: "why-winboost",
    "aria-labelledby": "why-winboost-title",
    style: {
      position: 'relative'
    }
  }, React.createElement("div", {
    className: "wrap",
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(34px,3.6vw,56px)',
      padding: 'var(--section-y) var(--gutter)'
    }
  }, React.createElement(WhySchema, null), React.createElement(WhoWeAre, null), React.createElement(OurPeople, null), React.createElement(High5, null), React.createElement(WhyItMatters, null), React.createElement(Innovation, null)));
}
Object.assign(window, {
  WhyWinBoost: WhyWinBoost,
  LetsTalk: LetsTalk
});